import { ERoutes } from 'common/const/enums.const';

// OAuth redirect_uri for "Login via dashboard": this page's origin plus the callback route, so login returns to
// whichever CRM hostname it started on. Sent to /auth/code and /auth/callback alike: the dashboard requires the
// same value on both legs, and the API only forwards it if it is in its OUTWARD_AUTH_REDIRECT_URIS allowlist.
export const getAuthRedirectUri = (): string => `${window.location.origin}${ERoutes.Auth}`;
